import { render, staticRenderFns } from "./Diag.vue?vue&type=template&id=4bb85f2e&scoped=true&"
import script from "./Diag.vue?vue&type=script&lang=js&"
export * from "./Diag.vue?vue&type=script&lang=js&"
import style0 from "./Diag.vue?vue&type=style&index=0&id=4bb85f2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb85f2e",
  null
  
)

export default component.exports